module.exports = __webpack_public_path__ + "img/back2.5aca8a55.png";